import * as actionTypes from 'actions';

const initialState = {
  mapLoading: false,
  wayPoints: [],
  markers: [],
  videos: []
};

const cameraPlaybackReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_WAY_POINTS: {
      return {
        ...state,
        wayPoints: action.wayPoints
      };
    }

    case actionTypes.UPDATE_MARKER: {
      return {
        ...state,
        markers: action.marker
      };
    }
    case actionTypes.SET_VIDEOS: {
      return {
        ...state,
        videos: action.videos
      };
    }

    default: {
      return state;
    }
  }
};

export default cameraPlaybackReducer;
